<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>¡Se han extraviado algunas piezas de esta sala!
      Descubre las pistas y resuelve los Mini-juegos para recuperarlas</h2>
  </div>
</template>

<script>
export default {
  name: "InfoBanner",
  data() {
    return {};
  }
};
</script>
